import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import {
  StyledBox,
  StyledList,
  StyledElement,
  StyledLink,
  StyledOuterLink,
  StyledLogout,
  StyledIconLogout
} from './style';
import { Logout } from '../../../../assets/images/index';

/** HOC */
import withOutsideClick from '../../views/Common/ClickOutside';

const MenuBoxView = ({
  type,
  className,
  logout,
  goCMS,
  show,
  idEmployee,
  idDepartment,
  onClickOption
}) => (
  <StyledBox className={className}>
    <StyledList type={type} show={show}>
      <StyledElement>
        <NavLink
          to={{
            pathname: `/perfil/${idEmployee}/mi_perfil`,
            state: { fromExternalMenu: true }
          }}
          onClick={onClickOption}
        >
          <StyledLink href="">Mi perfil</StyledLink>
        </NavLink>
        <NavLink
          to={{
            pathname: `/departamento/${idDepartment}/informacion_general`,
            state: { fromExternalMenu: true }
          }}
          onClick={onClickOption}
        >
          <StyledLink href="">Mi equipo</StyledLink>
        </NavLink>
      </StyledElement>
      {/* <StyledElement>
        <StyledLink href="">Nóminas</StyledLink>
      </StyledElement> */}
      {/* <StyledElement>
        <NavLink to="/contactos">
          <StyledLink href="">Contactos</StyledLink>
        </NavLink>
      </StyledElement> */}
      <StyledElement>
        <NavLink to="/agenda">
          <StyledLink href="">Agenda</StyledLink>
        </NavLink>
      </StyledElement>
      <StyledElement>
        <NavLink to="/perfil/control-acceso">
          <StyledLink href="">Control de acceso</StyledLink>
        </NavLink>
      </StyledElement>
      <StyledElement>
        <StyledOuterLink
          href="https://www.office.com/?auth=2&home=1"
          target="_blank"
        >
          Office
        </StyledOuterLink>
      </StyledElement>
      <StyledElement>
        <StyledOuterLink
          href="https://intranetapi.atresmedia.com/atresnet/oauth?redirect=home"
          target="_blank"
        >
          Workflow
        </StyledOuterLink>
      </StyledElement>
      <StyledElement onClick={goCMS}>
        <StyledLink>Ir al CMS</StyledLink>
      </StyledElement>
      <StyledLogout onClick={logout}>
        <StyledIconLogout svg={Logout} />
        Salir
      </StyledLogout>
    </StyledList>
  </StyledBox>
);
MenuBoxView.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string
};

MenuBoxView.defaultProps = {
  type: 'colorOne'
};

export default withOutsideClick(MenuBoxView);
